import { render, staticRenderFns } from "./professionField.vue?vue&type=template&id=23108bc4&scoped=true"
import script from "./professionField.vue?vue&type=script&lang=js"
export * from "./professionField.vue?vue&type=script&lang=js"
import style0 from "./professionField.vue?vue&type=style&index=0&id=23108bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23108bc4",
  null
  
)

export default component.exports